import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import Boton from "./Boton";
import { Scrudo, SEtiqueta, SInput } from "./general.js";
import { Usuario } from "./contexto/ClasesGrales"

export default function CRUDusuario({ setUsuario, usuario, set }) {
  let { firebase } = useContext(AppContext);

  const [u, setU] = useState(usuario ? usuario : new Usuario());
  const [imageAsFile, setImageAsFile] = useState(null);
  const [change, setChange] = useState(false)

  useEffect(() => {
    setU(usuario);
    setImageAsFile(null);
  }, [usuario]);

  function actualizarUsuario() {
    if (imageAsFile) {
      const uploadTask = firebase.storage.ref(`usuarios/fotos/${u.foto}`).put(imageAsFile);

      uploadTask.on(
        "state_changed",
        (snapShot) => {
          var progress = (snapShot.bytesTransferred / snapShot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
        },
        (err) => {
          console.log("Error al cargar la foto", err);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            u.passw = "pepe";
            u.url = downloadURL;
            firebase.actualizarUsuario(u);
            set(false);
          });
        }
      );
    } else {
      firebase.actualizarUsuario(u);
      set(false);
    }
    setChange(false)
  }

  return (
    <div style={Scrudo}>
      <div style={SDataEntry}>
        <div style={SEtiqueta}>Id:</div>
        <input
          type="text"
          maxLength="3"
          style={SInput}
          value={u.id}
          onChange={(e) => {
            e.persist(); setChange(true);
            setU((u) => ({ ...u, id: e.target.value }));
          }}
        ></input>
        <div style={SEtiqueta}>Nombre:</div>
        <input
          type="text"
          style={SInput}
          value={u.nombre}
          onChange={(e) => {
            e.persist(); setChange(true);
            setU((u) => ({ ...u, nombre: e.target.value }));
          }}
        ></input>
        <div style={SEtiqueta}>Email:</div>
        <input
          type="email"
          style={SInput}
          value={u.email}
          onChange={(e) => {
            e.persist(); setChange(true);
            setU((u) => ({ ...u, email: e.target.value }));
          }}
        ></input>
        <div style={SEtiqueta}>Horas x semana:</div>
        <input
          type="number"
          max="200"
          min="0"
          style={SInput}
          value={u.horassemana}
          onChange={(e) => {
            e.persist(); setChange(true);
            setU((u) => ({ ...u, horassemana: e.target.value }));
          }}
        ></input>
        <div style={SEtiqueta}>Rol:</div>
        <select
          value={u.rol}
          onChange={(e) => {
            e.persist(); setChange(true);
            setU((u) => ({ ...u, rol: e.target.value }));
          }}
          style={SInput}
        >
          {Object.keys(firebase.dataRoles).map((r, i) => (
            <option key={i} value={r}>
              {r}
            </option>
          ))}
        </select>
        <div style={SEtiqueta}>Foto:</div>
        <input
          type="file"
          accept="image/*"
          style={SInput}
          onChange={(e) => {
            e.persist(); setChange(true);
            setImageAsFile(e.target.files[0]);
            setU((u) => ({ ...u, foto: e.target.files[0].name }));
          }}
        ></input>
      </div>
      <div>
        <Boton accion={actualizarUsuario} change={change} />
      </div>
    </div >
  );
}

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "50% 50%",
  rowGap: "5px",
  columnGap: "5px",
};

